// extracted by mini-css-extract-plugin
export default {"deviceContractsContainer":"ContractDetailsPage_deviceContractsContainer__uV7Nu","deviceContractRow":"ContractDetailsPage_deviceContractRow__GNI7q"};